/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'class-work': {
    width: 39,
    height: 38,
    viewBox: '0 0 39 38',
    data: `<desc>Created using Figma</desc><use xlink:href="#svgicon-class-work-a" transform="translate(0 4)" fill="#F5D78B"/><use xlink:href="#svgicon-class-work-b" transform="rotate(-130 18.786 4.023)" fill="#3847B6"/><defs><path pid="0" id="svgicon-class-work-a" d="M34 17c0 9.389-7.611 17-17 17S0 26.389 0 17 7.611 0 17 0s17 7.611 17 17z"/><path pid="1" id="svgicon-class-work-b" d="M0 0h14.568v14.568H0V0z"/></defs>`
  }
})
